import React from "react";
import Header from "../../../components/molecules/Header";
import {
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  ListItemIcon,
  IconButton,
  List,
  ListSubheader,
  Divider,
} from "@material-ui/core";
import { auth } from "../../../components/firebase/FirebaseProvider";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import DnsIcon from "@material-ui/icons/Dns";
import ChromeReaderModeIcon from "@material-ui/icons/ChromeReaderMode";
import LanguageIcon from "@material-ui/icons/Language";
import YouTubeIcon from "@material-ui/icons/YouTube";
import TelegramIcon from "@material-ui/icons/Telegram";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";
import CreateIcon from "@material-ui/icons/Create";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import FingerprintIcon from "@material-ui/icons/Fingerprint";
import Logo from "../../../assets/icon/LogoMarket";
import { useHistory } from "react-router-dom";
// useStyles
import useStyles from "./style";

function AkunNotActive() {
  const classes = useStyles();

  const history = useHistory();

  const logout = () => {
    auth.signOut();
  };

  return (
    <>
      <Header type="with-title" title="Akun" onClick={() => history.goBack()} />
      <div style={{ paddingTop: 15 }}>
        <div className={classes.wrapList}>
          <List className={classes.listPadding}>
            <ListItem button onClick={() => history.push("/akun/ubahseller")}>
              <ListItemIcon>
                <CreateIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Ubah Profil Seller" />
              <ListItemSecondaryAction>
                <IconButton
                  edge="end"
                  size="small"
                  onClick={() => history.push("/akun/ubahseller")}
                >
                  <NavigateNextIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
            <ListItem button onClick={() => history.push("/alamat")}>
              <ListItemIcon>
                <ChromeReaderModeIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Daftar Alamat Pembeli" />
              <ListItemSecondaryAction>
                <IconButton
                  edge="end"
                  size="small"
                  onClick={() => history.push("/alamat")}
                >
                  <NavigateNextIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          </List>
          <List
            className={classes.listPadding}
            subheader={
              <ListSubheader className={classes.list} disableSticky={true}>
                Fitur Member
              </ListSubheader>
            }
          >
            <ListItem button onClick={() => window.open("/stock-available")}>
              <ListItemIcon>
                <DnsIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="List Stok Produk" />
              <ListItemSecondaryAction>
                <IconButton edge="end" size="small">
                  <NavigateNextIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          </List>
          <List
            className={classes.listPadding}
            component="nav"
            subheader={
              <ListSubheader className={classes.list} disableSticky={true}>
                Tentang TokoRame
              </ListSubheader>
            }
          >
            <ListItem
              button
              onClick={() =>
                window.open("https://www.facebook.com/groups/189482992873307")
              }
            >
              <ListItemIcon>
                <ChromeReaderModeIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Grup FB Reseller" />
              <ListItemSecondaryAction>
                <IconButton edge="end" size="small">
                  <NavigateNextIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
            <ListItem
              button
              onClick={() => window.open("https://tokorame.co.id/blog")}
            >
              <ListItemIcon>
                <LanguageIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Blog Tokorame" />
              <ListItemSecondaryAction>
                <IconButton edge="end" size="small">
                  <NavigateNextIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
            <ListItem
              button
              onClick={() =>
                window.open("https://www.youtube.com/watch?v=uEvjev6x0eM")
              }
            >
              <ListItemIcon>
                <YouTubeIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="Video Tutorial Berjualan" />
              <ListItemSecondaryAction>
                <IconButton edge="end" size="small">
                  <NavigateNextIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
            <ListItem
              button
              onClick={() => window.open("https://t.me/mitratokorame")}
            >
              <ListItemIcon>
                <TelegramIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Chanel Telegram Seller" />
              <ListItemSecondaryAction>
                <IconButton edge="end" size="small">
                  <NavigateNextIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
            <ListItem
              button
              onClick={() =>
                window.open("https://www.instagram.com/tokorameofficial/")
              }
            >
              <ListItemIcon>
                <InstagramIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="Instagram Tokorame" />
              <ListItemSecondaryAction>
                <IconButton edge="end" size="small">
                  <NavigateNextIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
            <ListItem
              button
              onClick={() =>
                window.open("https://www.facebook.com/tokorameofficial")
              }
            >
              <ListItemIcon>
                <FacebookIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Facebook Tokorame" />
              <ListItemSecondaryAction>
                <IconButton edge="end" size="small">
                  <NavigateNextIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            {/* <Divider />
            <ListItem button onClick={() => history.push("/akun/feedback")}>
              <ListItemIcon>
                <RateReviewIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Beri Masukan" />
              <ListItemSecondaryAction>
                <IconButton edge="end" size="small">
                  <NavigateNextIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem> */}
          </List>
          <List>
            <ListItem button onClick={() => history.push("/akun/bantuan")}>
              <ListItemIcon>
                <Logo />
              </ListItemIcon>
              <ListItemText
                primary="Pusat Bantuan"
                secondary="TokoRame siap membantu temen-teman reseller. jam kerja Senin - Sabtu,Jam 08.00 - 17.00 WIB"
              />
              <ListItemSecondaryAction>
                <IconButton edge="end" size="small">
                  <NavigateNextIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          </List>
          <List
            className={classes.listPadding}
            subheader={
              <ListSubheader className={classes.list} disableSticky={true}>
                Keamanan
              </ListSubheader>
            }
          >
            <ListItem button onClick={() => history.push("/akun/ubahsandi")}>
              <ListItemIcon>
                <FingerprintIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="Ubah Kata Sandi" />
              <ListItemSecondaryAction>
                <IconButton edge="end" size="small">
                  <NavigateNextIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
          </List>
          <List className={classes.listPadding}>
            <ListItem button onClick={logout}>
              <ListItemIcon>
                <ExitToAppIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="Keluar" />
              <ListItemSecondaryAction>
                <IconButton edge="end" size="small">
                  <NavigateNextIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          </List>
        </div>
      </div>
    </>
  );
}

export default AkunNotActive;
